import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { Modal, PrimaryButton, SecondaryButton } from '../../components';
import { BiLinkExternal } from 'react-icons/bi';
import { BsShieldLock } from 'react-icons/bs';

import css from './LeavingSiteModal.css';

// Confirmation modal shown when a user clicks an external (non-Freedomly) link in a
// chat message. Warns about leaving the platform before opening the destination.
const LeavingSiteModal = props => {
  const { isOpen, url, onClose, onConfirm, onManageDisableScrolling } = props;

  return (
    <Modal
      id="LeavingSiteModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div className={css.content}>
        <div className={css.header}>
          <span className={css.iconCircle}>
            <BiLinkExternal className={css.headerIcon} />
          </span>
          <h2 className={css.title}>
            <FormattedMessage id="LeavingSiteModal.title" />
          </h2>
        </div>

        <p className={css.description}>
          <FormattedMessage id="LeavingSiteModal.description" />
        </p>

        <div className={css.urlBox}>
          <span className={css.urlLabel}>
            <FormattedMessage id="LeavingSiteModal.urlLabel" />
          </span>
          <span className={css.url}>{url}</span>
        </div>

        <div className={css.warningBox}>
          <BsShieldLock className={css.warningIcon} />
          <span className={css.warningText}>
            <FormattedMessage id="LeavingSiteModal.credentialsWarning" />
          </span>
        </div>

        <div className={css.buttons}>
          <SecondaryButton className={css.cancelButton} onClick={onClose}>
            <FormattedMessage id="LeavingSiteModal.cancel" />
          </SecondaryButton>
          <PrimaryButton className={css.continueButton} onClick={onConfirm}>
            <FormattedMessage id="LeavingSiteModal.continue" />
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

LeavingSiteModal.defaultProps = {
  isOpen: false,
  url: null,
};

LeavingSiteModal.propTypes = {
  isOpen: PropTypes.bool,
  url: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
};

export default LeavingSiteModal;
